import type { AssetClassName } from './generated/gql-enums';

export const ASSET_CLASS_COLLECTIBLE = 'collectible' satisfies AssetClassName;
export const ASSET_CLASS_COMPANY_EQUITY = 'company_equity' satisfies AssetClassName;
export const ASSET_CLASS_INSURANCE_POLICY = 'insurance_policy' satisfies AssetClassName;
export const ASSET_CLASS_OTHER = 'other' satisfies AssetClassName;
export const ASSET_CLASS_REAL_ESTATE = 'real_estate' satisfies AssetClassName;
export const ASSET_CLASS_VEHICLE = 'vehicle' satisfies AssetClassName;
